import { DefaultCursorPageSchema, QueryBooleanSchema, isDefined } from 'notable-common';
import { z } from 'zod';
import { PrevisitWorkflowStatusSchema } from './workflowStatus.js';
/** Route params for the staff endpoints addressing a single previsit form set. */
export const PrevisitFormSetIdParamsSchema = z.object({ previsitFormSetId: z.uuid() }).strict();
/** The authentication code lets a staff user open the patient's link, so asking for it is audited. */
export const PrevisitFormSetFindOneQuerySchema = z
    .object({
    includeAuthenticationCode: QueryBooleanSchema.default(false),
})
    .strict();
/** A form set hangs off exactly one of the two entities, so a lookup names at least one of them. */
export const PrevisitFormSetFindByEntityQuerySchema = z.union([
    z
        .object({
        encounterId: z.uuid().nullable().optional(),
        ehrInformationId: z.uuid(),
        includeAuthenticationCode: QueryBooleanSchema.default(false),
    })
        .strict(),
    z
        .object({
        encounterId: z.uuid(),
        ehrInformationId: z.uuid().nullable().optional(),
        includeAuthenticationCode: QueryBooleanSchema.default(false),
    })
        .strict(),
]);
/** One object with a refinement rather than a union, so the query publishes its parameters. */
export const PrevisitFormSetListQuerySchema = z
    .object({
    encounterId: z.uuid().optional().describe('Return only sets for this appointment.'),
    ehrInformationId: z
        .uuid()
        .optional()
        .describe('Return only sets for this patient record, across all of its appointments.'),
    page: DefaultCursorPageSchema,
})
    .strict()
    .refine((query) => isDefined(query.encounterId) || isDefined(query.ehrInformationId), {
    message: 'encounterId or ehrInformationId is required',
});
/** Template id to the parameters the template is rendered with, both free-form to the template. */
export const PrevisitFormSetTemplateParametersSchema = z.record(z.uuid(), z.record(z.string(), z.string()));
export const PrevisitFormSetCreateSchema = z.union([
    z
        .object({
        ehrInformationId: z.uuid(),
        formTemplates: PrevisitFormSetTemplateParametersSchema,
    })
        .strict(),
    z
        .object({
        encounterId: z.uuid(),
        formTemplates: PrevisitFormSetTemplateParametersSchema,
    })
        .strict(),
]);
export const PrevisitFormSetExpireSchema = z
    .object({ previsitFormSetIds: z.array(z.uuid()) })
    .strict();
/** Shared by every manual outreach endpoint: send all, sms, email and voice. */
export const PrevisitFormSetOutreachSchema = z
    .object({
    checkRateLimiter: z.boolean().default(true),
    checkDuplicates: z.boolean().default(true),
})
    .strict();
/** Notification content is the message the patient received, so asking for it is audited. */
export const PrevisitFormSetFindPatientNotificationsQuerySchema = z
    .object({
    includeContent: QueryBooleanSchema.default(false),
})
    .strict();
export const PrevisitFormSetGetFormQuerySchema = z
    .object({ previsitFormTemplateName: z.string().min(1).optional() })
    .strict();
export const PrevisitFormSetWorkflowEventCreateSchema = z
    .object({
    status: PrevisitWorkflowStatusSchema,
    reasonsForReview: z.array(z.string().min(1)).optional(),
})
    .strict();
//# sourceMappingURL=set.js.map